import React from 'react'
import { useLocation, useParams } from 'react-router-dom'
import axios from "axios";
import Moment from 'react-moment';
import Barcode from 'react-barcode';


import ReactLoading from 'react-loading';
import config from "../../config"
const Print_label_int = () => {
  const location = useLocation()
  const shipment_id = useParams()
  // console.log("shipment_id",shipment_id.shipment_id)

  let userDetail = localStorage.getItem('ship_rocket_user');
  // console.log("userDetail====", config.UserId);
  let userData = {};
  if (userDetail != null) {
    userData = JSON.parse(userDetail)
  }

  const [state, setState] = React.useState({ shipment_list: [], total: 0, company_info: {}, customer_label_setting: {} })
  // console.log("state",state)
  const [dimensionState, setdimensionState] = React.useState({ companyDetail: [] })
  const [isloading, setisloading] = React.useState(true)

  const [shipmentsList, setShipmentList] = React.useState([])

  React.useEffect(() => {

    shipment_list()
    dimension_detail()

  }, [])

  React.useEffect(() => {
    // console.log("ss", state.customer_label_setting.label_size_print);
    // if (state.customer_label_setting.label_size_print == "8x11") {
    //   let arr1 = [];
    //   for (let i = 0; i < state.shipment_list.length; i += 4)
    //     arr1.push(state.shipment_list.slice(i, i + 4));
    //   console.log(arr1);
    //   setShipmentList(arr1)

    // } else {
    //   console.log("else");
    //   setShipmentList(state.shipment_list)
    // }


  }, [])

  const shipment_list = () => {
    let dataToSend = {
      customer_id: userData.customer_id, shipment_id: shipment_id.shipment_id
    };

    // console.log("datatoSend",dataToSend)
    let url = config.apiUrl + '/shipment/print_label_shipments';

    // // console.log("headers => ", config.headers);


    axios.post(url, dataToSend, { headers: config.headers })
      .then((res) => {
        // console.log("responseJson => ", res);
        setState({ shipment_list: res.data.output, total: res.data.total, company_info: res.data.company_info, customer_label_setting: res.data.customer_label_setting })
        let limit = 4;

        if (res.data.customer_label_setting.label_size_print == "4x6") {
          limit = 1;
        }
        let arr1 = [];
        for (let i = 0; i < res.data.output.length; i += limit)
          arr1.push(res.data.output.slice(i, i + limit));
        console.log(arr1);
        setShipmentList(arr1)

        //  } else {
        //  console.log("else");
        //  setShipmentList(res.data.output)
        // }

        setisloading(false)
        setTimeout(() => {
          window.print();
        }, 1000)




      })
      .catch((error) => {
        //Hide Loader
        //   setLoadingstate({...loadingstate,loading:false})
        // console.log(error);
      });

  }
  const SenderAddress = () => {
    if (state.shipment_list[0].items.length > 0) {
      return state.shipment_list[0].items.reduce((previousValue, currentValue) => {
        return previousValue.item_weight + currentValue.item_weight
      })
    } else {
      return 0
    }
  }


  const dimension_detail = () => {
    let full_api = config.apiUrl + `/user/get_company_info_api`;
    let sendData = {};

    axios.post(full_api, sendData, { headers: config.headers }).then(res => {
      setdimensionState({ ...dimensionState, companyDetail: res.data.companyDetail });
      // console.log("rnmmmmm", res);
    }).catch((e) => {
      // toast.configure()
      //toast.error("Some thing went wrong")
      // console.log("----error:   ", e);
    })
  }
  const FunctionComponent = (shipment_id) => {
    // console.log("shipment_id == " , shipment_id)
    return <Barcode value={shipment_id.value} />;
  };
  const FunctionComponent1 = () => {
    return <Barcode value={state.shipment_list[0].carrier_tracking_number} />;
  };
  const tableStyle = {
    fontFamily: 'sans-serif',
    borderCollapse: 'collapse',
    width: '100%',
    fontSize: '13px',
    verticalAlign: 'top',
  };

  const trStyle = {
    textAlign: 'left',
    padding: '18px',
  };

  const thTdStyle = {
    padding: '1px 10px',
    verticalAlign: 'top',
  };

  const evenRowStyle = {
    backgroundColor: '#fff',
  };

  const borderStyle = {
    border: '2px solid #000',
  };

  const centerStyle = {
    textAlign: 'center',
  };

  const monospaceStyle = {
    font: '20px monospace',
  };

  const a4PaperHeightPx = Math.round((297 * 96) / 25.4);
  return (

    <div>
      {isloading == false ?
        shipmentsList.map((ships, index) => (
          <>


            <div className="pagebreak" key={index}>
              <section class="labling_929393">
                {(state.customer_label_setting.label_size_print == "8x11") ?
              
                  <div className='row label-8x11-layout'>
                    {ships.map((sub, index) =>
                    
                   
                    <div class="container mt-4">
                    <div class="label-box-intl">
                        <table className='table_intl'>
                            <tr className='tr_intl'>
                                <td colspan="" class="text-center" style={{width: "240px"}} className='td_intl'>
                                    <img src="../../../assets/images/logo_big2.png" class="img-fluid img_intl" />
                                </td>
                                <td colspan="2" class="text-center td_intl">
                                    <h6 className='h6_intl'>SHP WT: {sub.total_weight} KGS</h6>
                                    <h6 className='h6_intl'>DATE: <Moment format="MMM DD YYYY">
                        {new Date(sub.created*1000)}
            </Moment></h6>
                                    <h3 style={{borderTop: "1px solid #000"}}>{sub.type=="Parcel"?"SPX":"DOX"}</h3>
                                </td>
                            </tr>
                            <tr className='tr_intl' style={{fontSize: "14px" ,  fontWeight: "800"}}>
                                <td colspan="" class="td_intl">
                                    SHIPPER
                                </td>
                                <td colspan="2" class="td_intl">
                                    NO OF BOX
                                </td>
                            </tr>
                            <tr className='tr_intl'>
                                <td className='td_intl'>
                                    <div  style={{fontSize: "13px" ,  fontWeight: "600"}}>
                                    {sub.sender[0].name} <br/>
                                    {sub.sender[0].address}<br/>
                                    {sub.sender[0].city} - {sub.sender[0].pincode}
                                    </div>
                                </td>
                                <td colspan="2" class="text-center td_intl">
                                    <h1 style={{margin: "10px 0"}}>1/1</h1>
                                </td>
                            </tr>
                            <tr className='tr_intl' style={{fontSize: "14px" ,  fontWeight: "800"}}>
                                <td colspan="" class="td_intl">
                                    CONSIGNEE
                                </td>
                                <td colspan="2" class="td_intl">
                                    DESTINATION
                                </td>
                            </tr>
                            <tr className='tr_intl'>
                                <td className='td_intl'>
                                    <div  style={{fontSize: "13px" ,  fontWeight: "600"}}>
                                    {sub.receiver[0].name} <br/>
                                    {sub.receiver[0].address}<br/>
                                    {sub.receiver[0].city} - {sub.receiver[0].pincode}
                                    </div>
                                </td>
                                <td colspan="2" class="text-center td_intl">
                                    <h1 style={{margin: "10px 0"}}>{sub.receiver[0].country}</h1>
                                </td>
                            </tr>
                            <tr className='tr_intl'>
                                <td colspan="3" class="text-center td_intl"  style={{fontSize: "14px" ,  fontWeight: "800"}}>Tracking Number</td>
                            </tr>
                            <tr className='tr_intl'>
                                <td colspan="3" class="text-center td_intl"  style={{fontSize: "14px" ,  fontWeight: "800"}}>{sub.carrier_tracking_number}</td>
                            </tr>
                            <tr className='tr_intl'>
                                <td colspan="3" class="text-center td_intl">
                                    <img src="https://i.imgur.com/qvLSHmm.png" class="img-fluid img_intl" />
                                </td>
                            </tr>
                            <tr className='tr_intl'>
                                <td colspan="3" class="text-center td_intl"  style={{fontSize: "14px" ,  fontWeight: "600"}}>
                                    <span style={{float: "left" , margin: "0 19px"}}>SERVICE</span>
                                    <span style={{float: "right", margin: "0 19px"}}>{sub.service_provider}</span>
                                </td>
                            </tr>
                            <tr className='tr_intl'>
                                <td colspan="3" class="text-center td_intl"  style={{fontSize: "11px", fontWeight: "500", color: "blue"}}>WWW.SKYSHIP.IN</td>
                            </tr>
                        </table>
                    </div>
                </div>
                   
                
                    )}
                  
                  </div>
                 

                  : (state.customer_label_setting.label_size_print == "4x6") ?
                    <div className='row label4x6'>
                      {ships.map((sub, index) =>
                       <div class="col-12 col-md-5">
                           <div class="container mt-4">
                    <div class="label-box-intl">
                        <table className='table_intl'>
                            <tr className='tr_intl'>
                                <td colspan="" class="text-center" style={{width: "240px"}} className='td_intl'>
                                    <img src="../../../assets/images/logo_big2.png" class="img-fluid img_intl" />
                                </td>
                                <td colspan="2" class="text-center td_intl">
                                    <h6 className='h6_intl'>SHP WT: {sub.total_weight} KGS</h6>
                                    <h6 className='h6_intl'>DATE: <Moment format="MMM DD YYYY">
                        {new Date(sub.created*1000)}
            </Moment></h6>
                                    <h3 style={{borderTop: "1px solid #000"}}>{sub.type=="Parcel"?"SPX":"DOX"}</h3>
                                </td>
                            </tr>
                            <tr className='tr_intl' style={{fontSize: "14px" ,  fontWeight: "800"}}>
                                <td colspan="" class="td_intl">
                                    SHIPPER
                                </td>
                                <td colspan="2" class="td_intl">
                                    NO OF BOX
                                </td>
                            </tr>
                            <tr className='tr_intl'>
                                <td className='td_intl'>
                                    <div  style={{fontSize: "13px" ,  fontWeight: "600"}}>
                                    {sub.sender[0].name} <br/>
                                    {sub.sender[0].address}<br/>
                                    {sub.sender[0].city} - {sub.sender[0].pincode}
                                    </div>
                                </td>
                                <td colspan="2" class="text-center td_intl">
                                    <h1 style={{margin: "10px 0"}}>1/1</h1>
                                </td>
                            </tr>
                            <tr className='tr_intl' style={{fontSize: "14px" ,  fontWeight: "800"}}>
                                <td colspan="" class="td_intl">
                                    CONSIGNEE
                                </td>
                                <td colspan="2" class="td_intl">
                                    DESTINATION
                                </td>
                            </tr>
                            <tr className='tr_intl'>
                                <td className='td_intl'>
                                    <div  style={{fontSize: "13px" ,  fontWeight: "600"}}>
                                    {sub.receiver[0].name} <br/>
                                    {sub.receiver[0].address}<br/>
                                    {sub.receiver[0].city} - {sub.receiver[0].pincode}
                                    </div>
                                </td>
                                <td colspan="2" class="text-center td_intl">
                                    <h1 style={{margin: "10px 0"}}>{sub.receiver[0].country}</h1>
                                </td>
                            </tr>
                            <tr className='tr_intl'>
                                <td colspan="3" class="text-center td_intl"  style={{fontSize: "14px" ,  fontWeight: "800"}}>Tracking Number</td>
                            </tr>
                            <tr className='tr_intl'>
                                <td colspan="3" class="text-center td_intl"  style={{fontSize: "14px" ,  fontWeight: "800"}}>{sub.carrier_tracking_number}</td>
                            </tr>
                            <tr className='tr_intl'>
                                <td colspan="3" class="text-center td_intl">
                                    <img src="https://i.imgur.com/qvLSHmm.png" class="img-fluid img_intl" />
                                </td>
                            </tr>
                            <tr className='tr_intl'>
                                <td colspan="3" class="text-center td_intl"  style={{fontSize: "14px" ,  fontWeight: "600"}}>
                                    <span style={{float: "left" , margin: "0 19px"}}>SERVICE</span>
                                    <span style={{float: "right", margin: "0 19px"}}>{sub.service_provider}</span>
                                </td>
                            </tr>
                            <tr className='tr_intl'>
                                <td colspan="3" class="text-center td_intl"  style={{fontSize: "11px", fontWeight: "500", color: "blue"}}>WWW.SKYSHIP.IN</td>
                            </tr>
                        </table>
                    </div>
                </div>
 
                   </div>
                      )}
                    </div>
                    :
                    Object.keys(state.customer_label_setting).length === 0 ?
                
                    <div className='row label-8x11-layout'>
                    {ships.map((sub, index) =>
                    
                   
                    <div className="col-12 col-md-5">
                  <div class="container mt-4">
                    <div class="label-box-intl">
                        <table className='table_intl'>
                            <tr className='tr_intl'>
                                <td colspan="" class="text-center" style={{width: "240px"}} className='td_intl'>
                                    <img src="../../../assets/images/logo_big2.png" class="img-fluid img_intl" />
                                </td>
                                <td colspan="2" class="text-center td_intl">
                                    <h6 className='h6_intl'>SHP WT: {sub.total_weight} KGS</h6>
                                    <h6 className='h6_intl'>DATE: <Moment format="MMM DD YYYY">
                        {new Date(sub.created*1000)}
            </Moment></h6>
                                    <h3 style={{borderTop: "1px solid #000"}}>{sub.type=="Parcel"?"SPX":"DOX"}</h3>
                                </td>
                            </tr>
                            <tr className='tr_intl' style={{fontSize: "14px" ,  fontWeight: "800"}}>
                                <td colspan="" class="td_intl">
                                    SHIPPER
                                </td>
                                <td colspan="2" class="td_intl">
                                    NO OF BOX
                                </td>
                            </tr>
                            <tr className='tr_intl'>
                                <td className='td_intl'>
                                    <div  style={{fontSize: "13px" ,  fontWeight: "600"}}>
                                    {sub.sender[0].name} <br/>
                                    {sub.sender[0].address}<br/>
                                    {sub.sender[0].city} - {sub.sender[0].pincode}
                                    </div>
                                </td>
                                <td colspan="2" class="text-center td_intl">
                                    <h1 style={{margin: "10px 0"}}>1/1</h1>
                                </td>
                            </tr>
                            <tr className='tr_intl' style={{fontSize: "14px" ,  fontWeight: "800"}}>
                                <td colspan="" class="td_intl">
                                    CONSIGNEE
                                </td>
                                <td colspan="2" class="td_intl">
                                    DESTINATION
                                </td>
                            </tr>
                            <tr className='tr_intl'>
                                <td className='td_intl'>
                                    <div  style={{fontSize: "13px" ,  fontWeight: "600"}}>
                                    {sub.receiver[0].name} <br/>
                                    {sub.receiver[0].address}<br/>
                                    {sub.receiver[0].city} - {sub.receiver[0].pincode}
                                    </div>
                                </td>
                                <td colspan="2" class="text-center td_intl">
                                    <h1 style={{margin: "10px 0"}}>{sub.receiver[0].country}</h1>
                                </td>
                            </tr>
                            <tr className='tr_intl'>
                                <td colspan="3" class="text-center td_intl"  style={{fontSize: "14px" ,  fontWeight: "800"}}>Tracking Number</td>
                            </tr>
                            <tr className='tr_intl'>
                                <td colspan="3" class="text-center td_intl"  style={{fontSize: "14px" ,  fontWeight: "800"}}>{sub.carrier_tracking_number}</td>
                            </tr>
                            <tr className='tr_intl'>
                                <td colspan="3" class="text-center td_intl">
                                    <img src="https://i.imgur.com/qvLSHmm.png" class="img-fluid img_intl" />
                                </td>
                            </tr>
                            <tr className='tr_intl'>
                                <td colspan="3" class="text-center td_intl"  style={{fontSize: "14px" ,  fontWeight: "600"}}>
                                    <span style={{float: "left" , margin: "0 19px"}}>SERVICE</span>
                                    <span style={{float: "right", margin: "0 19px"}}>{sub.service_provider}</span>
                                </td>
                            </tr>
                            <tr className='tr_intl'>
                                <td colspan="3" class="text-center td_intl"  style={{fontSize: "11px", fontWeight: "500", color: "blue"}}>WWW.SKYSHIP.IN</td>
                            </tr>
                        </table>
                    </div>
                </div>
                    </div>
                   
                
                    )}
                  
                  </div>  
               :
               <div className='row label-8x11-layout'>
               {ships.map((sub, index) =>
               
              
               <div className="col-12 col-md-5">
             <div class="container mt-4">
                    <div class="label-box-intl">
                        <table className='table_intl'>
                            <tr className='tr_intl'>
                                <td colspan="" class="text-center" style={{width: "240px"}} className='td_intl'>
                                    <img src="../../../assets/images/logo_big2.png" class="img-fluid img_intl" />
                                </td>
                                <td colspan="2" class="text-center td_intl">
                                    <h6 className='h6_intl'>SHP WT: {sub.total_weight} KGS</h6>
                                    <h6 className='h6_intl'>DATE: <Moment format="MMM DD YYYY">
                        {new Date(sub.created*1000)}
            </Moment></h6>
                                    <h3 style={{borderTop: "1px solid #000"}}>{sub.type=="Parcel"?"SPX":"DOX"}</h3>
                                </td>
                            </tr>
                            <tr className='tr_intl' style={{fontSize: "14px" ,  fontWeight: "800"}}>
                                <td colspan="" class="td_intl">
                                    SHIPPER
                                </td>
                                <td colspan="2" class="td_intl">
                                    NO OF BOX
                                </td>
                            </tr>
                            <tr className='tr_intl'>
                                <td className='td_intl'>
                                    <div  style={{fontSize: "13px" ,  fontWeight: "600"}}>
                                    {sub.sender[0].name} <br/>
                                    {sub.sender[0].address}<br/>
                                    {sub.sender[0].city} - {sub.sender[0].pincode}
                                    </div>
                                </td>
                                <td colspan="2" class="text-center td_intl">
                                    <h1 style={{margin: "10px 0"}}>1/1</h1>
                                </td>
                            </tr>
                            <tr className='tr_intl' style={{fontSize: "14px" ,  fontWeight: "800"}}>
                                <td colspan="" class="td_intl">
                                    CONSIGNEE
                                </td>
                                <td colspan="2" class="td_intl">
                                    DESTINATION
                                </td>
                            </tr>
                            <tr className='tr_intl'>
                                <td className='td_intl'>
                                    <div  style={{fontSize: "13px" ,  fontWeight: "600"}}>
                                    {sub.receiver[0].name} <br/>
                                    {sub.receiver[0].address}<br/>
                                    {sub.receiver[0].city} - {sub.receiver[0].pincode}
                                    </div>
                                </td>
                                <td colspan="2" class="text-center td_intl">
                                    <h1 style={{margin: "10px 0"}}>{sub.receiver[0].country}</h1>
                                </td>
                            </tr>
                            <tr className='tr_intl'>
                                <td colspan="3" class="text-center td_intl"  style={{fontSize: "14px" ,  fontWeight: "800"}}>Tracking Number</td>
                            </tr>
                            <tr className='tr_intl'>
                                <td colspan="3" class="text-center td_intl"  style={{fontSize: "14px" ,  fontWeight: "800"}}>{sub.carrier_tracking_number}</td>
                            </tr>
                            <tr className='tr_intl'>
                                <td colspan="3" class="text-center td_intl">
                                    <img src="https://i.imgur.com/qvLSHmm.png" class="img-fluid img_intl" />
                                </td>
                            </tr>
                            <tr className='tr_intl'>
                                <td colspan="3" class="text-center td_intl"  style={{fontSize: "14px" ,  fontWeight: "600"}}>
                                    <span style={{float: "left" , margin: "0 19px"}}>SERVICE</span>
                                    <span style={{float: "right", margin: "0 19px"}}>{sub.service_provider}</span>
                                </td>
                            </tr>
                            <tr className='tr_intl'>
                                <td colspan="3" class="text-center td_intl"  style={{fontSize: "11px", fontWeight: "500", color: "blue"}}>WWW.SKYSHIP.IN</td>
                            </tr>
                        </table>
                    </div>
                </div>
               </div>
              
           
               )}
             
             </div>  }


                {/* : ""}  */}

              </section>

            </div >


          </>
        )) : <div style={{ display: 'flex', justifyContent: 'center', marginLeft: "80px", alignItems: 'center', marginTop: "-200px", height: '100vh' }}>
          <ReactLoading type={"spin"} color={"#0d6efd"} height={40} width={60} />
        </div>}

    </div >
  )
}

export default Print_label_int